import { Box, List, ListItem, Skeleton, Stack } from '@mui/material';

export const CheckBoxListSkeleton = () => {
  const renderSkeleton = () => {
    return (
      <>
        <ListItem>
          <Stack direction="row" spacing={1} alignItems="center">
            <Box sx={{ width: 20 }}>
              <Skeleton variant="rectangular" />
            </Box>
            <Box sx={{ width: 100 }}>
              <Skeleton animation="wave" />
            </Box>
          </Stack>
        </ListItem>
        <ListItem>
          <Stack direction="row" spacing={1} alignItems="center">
            <Box sx={{ width: 20 }}>
              <Skeleton variant="rectangular" />
            </Box>
            <Box sx={{ width: 100 }}>
              <Skeleton animation="wave" />
            </Box>
          </Stack>
        </ListItem>
        <ListItem>
          <Stack direction="row" spacing={1} alignItems="center">
            <Box sx={{ width: 20 }}>
              <Skeleton variant="rectangular" />
            </Box>
            <Box sx={{ width: 100 }}>
              <Skeleton animation="wave" />
            </Box>
          </Stack>
        </ListItem>
      </>
    );
  };

  return <List sx={{ padding: '0' }}>{renderSkeleton()}</List>;
};
